import { getParamDependentValues, queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';
import { REPORT_SETTINGS_PREFIX } from 'modules/taboola-common-frontend-modules/storage/DBStorage/constant';
import { PERSISTENCE_TYPE } from 'modules/taboola-common-frontend-modules/storage/persistenceType';
import { ACCOUNT_ID } from '../../../../../hooks';
import { REPORT_ACTIVE_FILTERS_DYNAMIC_PROP } from '../../../../scheduled-reports/config/dynamicReportViewProps';
import { isStaticReport } from '../../../config/isStaticDynamicReport';
import { REPORT_ID } from './useSelectedReportId';

export const REPORT_FILTER_STATUS = 'filters_active';

export const getStaticReportFilterStatusKey = reportId => `${REPORT_SETTINGS_PREFIX}.${reportId}.filterActive`;
export const getDynamicReportFilterStatusKey = (reportId, accountId) =>
    `${accountId}.${reportId}.${REPORT_ACTIVE_FILTERS_DYNAMIC_PROP}`;

export const useReportFiltersStatus = queryParamHookFactory(REPORT_FILTER_STATUS, {
    deserializer: value => {
        if (!value) {
            return;
        }

        try {
            const parsedValue = JSON.parse(value);
            return parsedValue;
        } catch (err) {
            return false;
        }
    },
    dependencies: { queryParams: [REPORT_ID, ACCOUNT_ID] },
    persist: PERSISTENCE_TYPE.REPORT_STORAGE,
    storageKeyGetter: (paramName, metadata) => {
        const dependentValues = getParamDependentValues(paramName, metadata);
        const reportId = dependentValues[REPORT_ID];

        if (isStaticReport(reportId)) {
            return getStaticReportFilterStatusKey(dependentValues[REPORT_ID]);
        }
        return getDynamicReportFilterStatusKey(reportId, dependentValues[ACCOUNT_ID]);
    },
});
